
export const TODO_FETCH   = 'TODO_FETCH';
export const TODO_UPDATE  = 'TODO_UPDATE';
export const TODO_APPEND  = 'TODO_APPEND';
export const TODO_REMOVE  = 'TODO_REMOVE';
export const TODO_CONFIRM = 'TODO_CONFIRM';
// export const TODO_UPLOAD  = 'TODO_UPLOAD';
